import { ChangeDetectionStrategy, Component, Inject, LOCALE_ID, OnInit, Optional, input } from '@angular/core';
import { ProfileStore } from '@fry/lib/profile';
import { ProfileHistoryGroup, User, UserService, UsersStore, } from '@fry/lib/users';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { UsersModule } from '../users.module';
import { AsyncPipe, CommonModule } from '@angular/common';
import { UnboxedModule } from '@fry/ui';
import { RouterModule } from '@angular/router';
import { FryCommonModule } from '@fry/components/common';
import { BoardCard } from '@fry/boards/lib';
import { MatButtonModule } from '@angular/material/button';

enum MenuIcon {
  Open = 'close',
  Closed = 'more_horiz'
}

@Component({
    imports: [
        CommonModule,
        FryCommonModule,
        UnboxedModule,
        UsersModule,
        RouterModule,
        AsyncPipe,
        MatButtonModule,
    ],
    selector: 'eas-profile-view-card',
    templateUrl: './profile-card.view.component.html',
    styleUrls: ['./profile-card.view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileViewCardComponent
  implements OnInit {
  static key = 'ProfileCardComponent';
  title = '';

  card = input.required<BoardCard>();


  user$: Observable<User>;
  user: User;
  menuIcon: MenuIcon;
  remote: boolean;
  history: ProfileHistoryGroup[];
  roles: string[];

  historyFilter: 'current' | 'previous' | 'future' | 'all' = 'current';

  constructor(
    private profile: ProfileStore,
    private users: UsersStore,
    @Optional() private userService: UserService,
    @Inject(LOCALE_ID) private lc: string
  ) {

    console.log("SETUP", this.lc);

    if (userService) {
      this.remote = true;
      this.user$ = of(this.userService.user);
    } else {
      this.remote = false;
      this.user$ = this.profile.getCurrent().pipe(
        switchMap(item => this.users.getByUsername(item.doc.user)),
      );
    }
    this.user$ = this.user$.pipe(
      tap(user => {
        this.user = user;
        this.history = user.history();
        this.roles = user.getRoles();
      }),
    );
  }

  ngOnInit() {
    if (this.userService) {
      this.title = this.card().options.title || $localize `Profile`;
    } else {
      this.title = this.card().options.owntitle || this.card().options.title || $localize `My profile`;
    }
    this.menuClosed();
  }

  public menuOpened() {
    this.menuIcon = MenuIcon.Open;
  }

  public menuClosed() {
    this.menuIcon = MenuIcon.Closed;
  }
}
